<template>
  <v-dialog v-model="dialog" width="1000">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" rounded small color="primary">{{$t('Networks.permissions')}}</v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{$t('Networks.Dialog.title')}}</v-card-title>

      <v-card-text>
        <v-checkbox v-model="admin" :label="`admin`"></v-checkbox>
        <v-checkbox v-model="user" :label="`user`"></v-checkbox>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">{{$t('Networks.back')}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t('Networks.save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    userId: String,
    networkId: String,
    scopes: Array
  },
  data() {
    return {
      dialog: false,
      admin: false,
      user: false
    };
  },
  beforeMount: function() {
    this.admin =
      this.scopes.findIndex(scope => {
        return scope == "admin";
      }) >= 0;

    this.user =
      this.scopes.findIndex(scope => {
        return scope == "user";
      }) >= 0;
  },
  computed: {
    addscopes: function() {
      let array = [];
      if (this.admin) array.push("admin");
      if (this.user) array.push("user");
      return array;
    },
    deletescopes: function() {
      let array = [""];
      if (!this.admin) array.push("admin");
      if (!this.user) array.push("user");
      return array;
    }
  },
  methods: {
    save: function() {
      axios
        .put(
          process.env.VUE_APP_API_ADDR +
            "/api/user/" +
            this.userId +
            "/network/" +
            this.networkId,
          {
            scopes: this.addscopes
          },
          {
            headers: { Authorization: tokenStore.getToken() }
          }
        )
        .then(res => {
          if (res.data.success) {
            axios
              .delete(
                process.env.VUE_APP_API_ADDR +
                  "/api/user/" +
                  this.userId +
                  "/network/" +
                  this.networkId,
                {
                  headers: {
                    Authorization: tokenStore.getToken()
                  },
                  data: {
                    scopes: this.deletescopes
                  }
                }
              )
              .then(res => {
                if (res.data.success) {
                  this.dialog = false;
                  this.$emit("permissionsupdated");
                }
              })
              .catch(err => {
                if (err) {
                  this.$emit("error", err.response.data.errorMessage);
                }
              });
          }
        })
        .catch(err => {
          if (err) {
            this.$emit("error", err.response.data.errorMessage);
          }
        });
    }
  }
};
</script>